import { useState } from 'react'
import { App } from 'antd'
import { autoDownload } from '../../../utils/helpers'
import { fetchInvestmentTemplate } from '../service/investmentService'

export const useInvestmentTemplate = () => {
  const { message } = App.useApp()
  const [isLoading, setIsLoading] = useState(false)

  const handleExport = async () => {
    setIsLoading(true)
    try {
      const data = await fetchInvestmentTemplate()
      autoDownload(`investments-template.xlsx`, data)
    } catch (err) {
      message.error('Failed to download file')
    } finally {
      setIsLoading(false)
    }
  }

  return { download: handleExport, isLoading }
}
